import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Button, Container, Title, View } from '@common/components';
import { Row, Col, Layout } from 'antd';
import { Helmet } from 'react-helmet';
import { fetchModulesBySubmoduleCode } from '@resources/Module/actions';
import {
	fetchSuppliers,
	fetchSuppliersByOrganizationModule,
	clearSuppliers,
} from '@resources/Supplier/actions';
import { FormattedMessage, useIntl } from 'react-intl';
import { moduleByParam } from '@common/utils/module';
import { SupplierItem } from '@fragments/items';
import CreateModal from './Create';
import UpdateModal from './Update';

const { Content } = Layout;

const Supplier = (props) => {
	const {
		suppliers,
		fetchSuppliers,
		fetchSuppliersByOrganizationModule,
		fetchModulesBySubmoduleCode,
		clearSuppliers,
		match,
		organization,
	} = props;
	const intl = useIntl();

	const [create, setCreate] = useState(false);
	const [update, setUpdate] = useState(false);
	const [module, setModule] = useState({});

	useEffect(() => {
		const func = async () => {
			const { data } = await fetchModulesBySubmoduleCode('supplier');
			await clearSuppliers();
			const param = match?.params || {};
			const modByParam = moduleByParam(data?.data, param);

			setModule(modByParam);

			organization?._id && modByParam
				? await fetchSuppliersByOrganizationModule(
						organization?._id,
						modByParam && modByParam._id,
						param[`moduleId`]
				  )
				: await fetchSuppliers();
		};

		func();
	}, [
		fetchSuppliers,
		fetchModulesBySubmoduleCode,
		fetchSuppliersByOrganizationModule,
		clearSuppliers,
		organization,
	]);

	const parseDataSource = useCallback(() => {
		return suppliers.map((supplier) => {
			return {
				key: supplier._id,
				...supplier,
			};
		});
	}, [suppliers]);

	return (
		<Content>
			<Helmet>
				<title>
					{intl.formatMessage({
						id: 'common.supplier.management',
						defaultMessage: 'Supplier Management',
					})}
				</title>
			</Helmet>

			<CreateModal
				{...props}
				module={module}
				visible={create}
				onCancel={() => setCreate(false)}
			/>
			<UpdateModal
				{...props}
				module={module}
				visible={update}
				onCancel={() => setUpdate(false)}
			/>
			<View>
				<Container>
					<Row
						type="flex"
						justify="center"
						align="middle"
						className="mt-5">
						<Col md={{ span: 12 }}>
							<Title>
								<FormattedMessage
									id="common.supplier"
									defaultMessage="Supplier"
								/>
							</Title>
						</Col>
						<Col md={{ span: 12 }} className="text-right">
							<Button
								type="primary"
								onClick={() => setCreate(true)}>
								<FormattedMessage
									id="common.new.supplierItem"
									defaultMessage="New Supplier Item"
								/>
							</Button>
						</Col>
					</Row>
					<Row type="flex" gutter={16}>
						{parseDataSource() &&
							parseDataSource().map((supplier, index) => (
								<Col
									xs={24}
									sm={12}
									md={12}
									lg={8}
									key={`empty-post-${index}`}
									className="mt-4">
									<SupplierItem
										supplier={supplier}
										onEdit={() => setUpdate(supplier._id)}
									/>
								</Col>
							))}
					</Row>
				</Container>
			</View>
		</Content>
	);
};

const mapStateToProps = ({
	suppliers,
	modules,
	event,
	facility,
	cellGroup,
	ministry,
	organization,
	mission,
	service,
}) => {
	return {
		suppliers,
		modules,
		event,
		facility,
		cellGroup,
		ministry,
		organization,
		mission,
		service,
	};
};

export default connect(mapStateToProps, {
	fetchSuppliers,
	fetchSuppliersByOrganizationModule,
	fetchModulesBySubmoduleCode,
	clearSuppliers,
})(Supplier);
